import React from "react";
import { useNotify, useRefresh } from "react-admin";
import { Button } from "@mui/material";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import VerifiedIcon from "@mui/icons-material/Verified";
import dataProvider from "server/dataProvider";
import { tenants } from "utils/tenants";
import { studentRequests } from "api/studentApi";
import { settings } from "app";
import useConflictErrorModal from "server/components/Modals/useConflictErrorModal";
import { useNotifyError } from "utils/useNotifyError";

// onSuccess re-fetches data loaded outside react-admin's query cache, which refresh() cannot invalidate.
const WorkedOutDialog = ({ studentEducationId, classId, onSuccess }) => {
  const refresh = useRefresh();
  const notify = useNotify();
  const notifyError = useNotifyError();
  const { handleConflictError, ConflictErrorDialog } = useConflictErrorModal();

  const handleSubmit = async () => {
    try {
      await dataProvider.customRequest(studentRequests.markMakeUpMade(), { studentEducationId, classId }, "PUT");
    } catch (err) {
      notifyError(err);
      if (handleConflictError(err)) return;

      return false;
    }

    refresh();
    onSuccess?.();
    notify(
      settings.tenant !== tenants.MGU
        ? "Успешно отбелязахте упражненията като отработени"
        : "Успешно извинихте отсъствието",
      { type: "success" },
    );
  };

  return (
    <>
      <ConfirmModal
        onConfirm={handleSubmit}
        titleContent={settings.tenant !== tenants.MGU ? "Отбележи като отработено" : "Извини отсъствие"}
        triggerButton={
          <Button startIcon={<VerifiedIcon />}>
            {settings.tenant !== tenants.MGU ? "Отбележи като отработено" : "Извини отсъствие"}
          </Button>
        }
        message={
          settings.tenant !== tenants.MGU
            ? "Сигурни ли сте, че искате да потвърдите отработените упражнения?"
            : "Сигурни ли сте, че искате да извините отсъствието?"
        }
      />
      <ConflictErrorDialog />
    </>
  );
};

export default WorkedOutDialog;
